var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwaHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 717,
    height: 52,
    viewBox: "0 0 717 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M13.002 8.33L7 2.326.998 8.33l-.827-.827L7 .672l6.83 6.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M11 4c.667 0 1.305.125 1.914.375a4.92 4.92 0 0 1 1.625 1.086 4.92 4.92 0 0 1 1.086 1.625c.25.61.375 1.247.375 1.914a4.89 4.89 0 0 1-.39 1.95 5.03 5.03 0 0 1-1.07 1.59 5.03 5.03 0 0 1-1.59 1.07A4.89 4.89 0 0 1 11 14v-1c.552 0 1.07-.105 1.555-.316a4.08 4.08 0 0 0 1.27-.86 4.08 4.08 0 0 0 .859-1.27C14.894 10.07 15 9.553 15 9s-.105-1.07-.316-1.555a4.08 4.08 0 0 0-.86-1.27 4.08 4.08 0 0 0-1.27-.859A3.851 3.851 0 0 0 11 5H6.71l3.142 3.148-.704.704L4.797 4.5 9.148.148l.704.704L6.71 4H11zm-8.797.5l3.649 3.648-.704.704L.797 4.5 5.148.148l.704.704L2.203 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M8.602.648L15.953 8l-7.351 7.352-.704-.704L14.047 8.5H0v-1h14.047L7.898 1.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M8 4c.667 0 1.305.125 1.914.375a4.92 4.92 0 0 1 1.625 1.086 4.92 4.92 0 0 1 1.086 1.625c.25.61.375 1.247.375 1.914a4.89 4.89 0 0 1-.39 1.95 5.03 5.03 0 0 1-1.07 1.59 5.03 5.03 0 0 1-1.59 1.07A4.89 4.89 0 0 1 8 14v-1c.552 0 1.07-.105 1.555-.316a4.08 4.08 0 0 0 1.27-.86 4.08 4.08 0 0 0 .859-1.27C11.894 10.07 12 9.553 12 9s-.105-1.07-.316-1.555a4.08 4.08 0 0 0-.86-1.27 4.08 4.08 0 0 0-1.27-.859A3.851 3.851 0 0 0 8 5H2.71l3.142 3.148-.704.704L.797 4.5 5.148.148l.704.704L2.71 4H8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#323130",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: 12,
    transform: "translate(-19 -12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 71,
    y: 63
  }, "You")), /*#__PURE__*/React.createElement("text", {
    fill: "#605D5A",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: 12,
    transform: "translate(-19 -12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 71,
    y: 44
  }, "Yesterday 3:10 PM ")), /*#__PURE__*/React.createElement("text", {
    fill: "#212121",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: 14,
    fontWeight: 500,
    transform: "translate(-19 -12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 71,
    y: 25
  }, "Sender")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A5A5AB",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: 14,
    fontWeight: 500,
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.689,
    y: 24
  }, "S"))), /*#__PURE__*/React.createElement("path", {
    d: "M694 2h32v32h-32z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#231F20",
    transform: "rotate(178 358.378 17.636)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 2h32v32h-32z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#231F20",
    transform: "translate(630 11)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 2h32v32h-32z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#231F20",
    transform: "translate(666 10)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M586 2h32v32h-32z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#231F20",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#605D5A",
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h16v16H-1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwaHeader);
export default __webpack_public_path__ + "static/media/owa_header.17f2ed4afc035848554d0c821ba228d2.svg";
export { ForwardRef as ReactComponent };